import type { DemoKey } from '../types';

export const pa: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ਗਣਿਤ · ਸੰਖਿਆਕੀ',
  'app.title': 'ਸੰਖਿਆਕੀ',
  'panel.experiment': 'ਦ੍ਰਿਸ਼',
  'panel.params': 'ਪੈਰਾਮੀਟਰ',

  'exp.survey-explorer.title': 'ਸਰਵੇਖਣ ਖੋਜੀ',
  'exp.survey-explorer.desc': 'ਇੱਕ ਕਾਲਮ ਚੁਣੋ; ਡੇਮੋ ਸਹੀ ਸਾਰਾਂਸ਼ ਚੁਣਦਾ ਹੈ।',
  'exp.distribution-sculptor.title': 'ਵੰਡ ਮੂਰਤੀਕਾਰ',
  'exp.distribution-sculptor.desc': 'ਬਿੰਦੂ ਖਿੱਚੋ ਅਤੇ ਸੰਖਿਆਕੀ ਦੀ ਪ੍ਰਤਿਕਿਰਿਆ ਵੇਖੋ।',
  'exp.two-variable-lab.title': 'ਦੋ-ਚਰ ਪ੍ਰਯੋਗਸ਼ਾਲਾ',
  'exp.two-variable-lab.desc': 'ਖਿੰਡਾਅ, ਫਿੱਟ ਤੇ ਕਾਰਨ ਦਾ ਸਵਾਲ।',
  'exp.sampling-lab.title': 'ਨਮੂਨਾ ਪ੍ਰਯੋਗਸ਼ਾਲਾ',
  'exp.sampling-lab.desc': 'ਤਕਨੀਕ ਅਤੇ ਆਕਾਰ ਨਮੂਨਾ ਔਸਤ ਨੂੰ ਕਿਵੇਂ ਹਿਲਾਉਂਦੇ ਹਨ।',
  'exp.probability-diagrams.title': 'ਸੰਭਾਵਨਾ ਚਿੱਤਰ',
  'exp.probability-diagrams.desc': 'ਮਿਸ਼ਰਿਤ ਘਟਨਾਵਾਂ ਲਈ ਵੈੱਨ ਅਤੇ ਰੁੱਖ।',

  'type.qualitative-nominal.label': 'ਗੁਣਾਤਮਕ · ਨਾਮਕ',
  'type.qualitative-nominal.def': 'ਅੰਦਰੂਨੀ ਕ੍ਰਮ ਤੋਂ ਬਿਨਾਂ ਸ਼੍ਰੇਣੀਆਂ।',
  'type.qualitative-ordinal.label': 'ਗੁਣਾਤਮਕ · ਕ੍ਰਮਿਕ',
  'type.qualitative-ordinal.def': 'ਅਰਥਪੂਰਨ ਕ੍ਰਮ ਵਾਲੀਆਂ ਸ਼੍ਰੇਣੀਆਂ।',
  'type.qualitative-multi.label': 'ਗੁਣਾਤਮਕ · ਬਹੁ-ਮੁੱਲ',
  'type.qualitative-multi.def': 'ਹਰ ਨਿਰੀਖਣ ਉੱਤੇ ਕਈ ਟੈਗ।',
  'type.quantitative-discrete.label': 'ਮਾਤਰਾਤਮਕ · ਵਿਖੰਡੀ',
  'type.quantitative-discrete.def': 'ਨਿਰਧਾਰਤ ਕਦਮਾਂ ਵਿੱਚ ਸੰਖਿਆਵਾਂ।',
  'type.quantitative-continuous.label': 'ਮਾਤਰਾਤਮਕ · ਨਿਰੰਤਰ',
  'type.quantitative-continuous.def': 'ਨਿਰੰਤਰ ਮਾਪਦੰਡ ਉੱਤੇ ਸੰਖਿਆਵਾਂ।',

  'column.name.label': 'ਵਿਦਿਆਰਥੀ ਨਾਮ',
  'column.height_cm.label': 'ਉਚਾਈ',
  'column.shoe_size_eu.label': 'ਜੁੱਤੀ ਸਾਈਜ਼ (EU)',
  'column.study_hours.label': 'ਪੜ੍ਹਾਈ ਘੰਟੇ / ਹਫ਼ਤਾ',
  'column.test_score.label': 'ਟੈਸਟ ਅੰਕ',
  'column.sports_played.label': 'ਖੇਡੇ ਖੇਡ',
  'column.eye_color.label': 'ਅੱਖ ਦਾ ਰੰਗ',
  'column.commute_min.label': 'ਯਾਤਰਾ',
  'column.grade_year.label': 'ਜਮਾਤ',
  'column.homework_effort.label': 'ਘਰ ਦਾ ਕੰਮ ਜਤਨ',
  'column.ice-cream-sales.label': 'ਆਈਸਕ੍ਰੀਮ ਵਿਕਰੀ',
  'column.drownings.label': 'ਡੁੱਬਣ',
  'column.month.label': 'ਮਹੀਨਾ',
  'column.storks.label': 'ਲੰਮ-ਚੋਚ',
  'column.births.label': 'ਜਨਮ',
  'column.country_area_km2.label': 'ਦੇਸ਼ ਖੇਤਰ',
  'column.sleep_hours.label': 'ਨੀਂਦ ਘੰਟੇ',
  'column.reaction_ms.label': 'ਪ੍ਰਤਿਕਿਰਿਆ ਸਮਾਂ',

  'dataset.master-survey.label': 'ਜਮਾਤ ਸਰਵੇਖਣ',
  'dataset.master-survey.desc': '30 ਨਮੂਨਾ ਵਿਦਿਆਰਥੀ।',
  'dataset.spurious-ice-cream-vs-drownings.label': 'ਆਈਸਕ੍ਰੀਮ ਬਨਾਮ ਡੁੱਬਣ',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'ਦੋਵੇਂ ਮੌਸਮ ਨਾਲ ਉੱਚੇ-ਨੀਵੇਂ ਹੁੰਦੇ। ਡੁੱਬਣ ਆਈਸਕ੍ਰੀਮ ਵਿਕਰੀ ਨਹੀਂ ਬਣਾਉਂਦਾ।',
  'dataset.spurious-storks-vs-births.label': 'ਲੰਮ-ਚੋਚ ਬਨਾਮ ਜਨਮ',
  'dataset.spurious-storks-vs-births.desc': 'ਵੱਡੇ ਦੇਸ਼ਾਂ ਵਿੱਚ ਜ਼ਿਆਦਾ ਪੰਛੀ ਅਤੇ ਜਨਮ। ਪੰਛੀ ਕਾਰਨ ਨਹੀਂ।',
  'dataset.real-sleep-vs-reaction-time.label': 'ਨੀਂਦ ਬਨਾਮ ਪ੍ਰਤਿਕਿਰਿਆ',
  'dataset.real-sleep-vs-reaction-time.desc':
    'ਜ਼ਿਆਦਾ ਨੀਂਦ, ਤੇਜ਼ ਪ੍ਰਤਿਕਿਰਿਆ। ਅਸਲ ਨਕਾਰਾਤਮਕ ਸੰਬੰਧ — ਸੰਭਾਵੀ ਕਾਰਨ ਸਮੇਤ।',

  'tag.football.label': 'ਫੁੱਟਬਾਲ',
  'tag.basketball.label': 'ਬਾਸਕਟਬਾਲ',
  'tag.volleyball.label': 'ਵਾਲੀਬਾਲ',
  'tag.swimming.label': 'ਤੈਰਾਕੀ',
  'tag.none.label': 'ਕੋਈ ਨਹੀਂ',

  'population.gaussian.label': 'ਘੰਟਾ ਵਕਰ',
  'population.right-skewed.label': 'ਸੱਜੇ ਪਾਸੇ ਝੁਕਾਅ',
  'population.bimodal.label': 'ਦੋ ਸਿਖਰ',
  'population.uniform.label': 'ਇਕਸਾਰ',

  'venn.dice-even-or-prime.label': 'ਪਾਸਾ: ਸਮ ਜਾਂ ਮੂਲ',
  'venn.class-sports-2set.label': 'ਖੇਡ (2 ਸੈੱਟ)',
  'venn.class-sports-3set.label': 'ਖੇਡ (3 ਸੈੱਟ)',
  'venn.custom.label': 'ਕਸਟਮ',

  'tree.draw-without-replacement.label': 'ਬਿਨਾਂ ਵਾਪਸੀ',
  'tree.custom.label': 'ਕਸਟਮ',
  'tree.coin.heads': 'ਸ',
  'tree.coin.tails': 'ਪ',
  'tree.draw.start': 'ਥੈਲਾ: 2 ਲਾਲ, 3 ਨੀਲੀਆਂ',
  'tree.draw.red': 'ਲਾਲ',
  'tree.draw.blue': 'ਨੀਲਾ',
  'tree.custom.start': 'ਸ਼ੁਰੂ',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'ਹਿਸਟੋਗ੍ਰਾਮ',
  'card.cumulative': 'ਸੰਚਿਤ ਫ੍ਰੀਕਵੈਂਸੀ',
  'card.box': 'ਬਾਕਸ ਪਲਾਟ',
  'card.summary': '5-ਅੰਕ ਸਾਰਾਂਸ਼',
  'card.bar': 'ਬਾਰ ਚਾਰਟ',
  'card.mode': 'ਬਹੁਲਕ',
  'card.tag-frequency': 'ਟੈਗ ਫ੍ਰੀਕਵੈਂਸੀ',
  'card.mode-tag': 'ਟਾਪ ਟੈਗ',
  'card.empty-no-order': 'ਲਾਗੂ ਨਹੀਂ',
  'card.empty-multi': 'ਲਾਗੂ ਨਹੀਂ',
  'card.numberline': 'ਸੰਖਿਆ ਰੇਖਾ',
  'card.scatter': 'ਖਿੰਡਾਅ',
  'card.description': 'ਕੀ ਹੋ ਰਿਹਾ',
  'card.population': 'ਜਨਸੰਖਿਆ',
  'card.sampling-distribution': 'ਨਮੂਨਾ ਔਸਤ',
  'card.venn': 'ਵੈੱਨ',
  'card.tree': 'ਰੁੱਖ',
  'card.probabilities': 'ਸੰਭਾਵਨਾਵਾਂ',

  'param.dataset.label': 'ਡੇਟਾਸੈੱਟ',
  'param.column.label': 'ਕਾਲਮ',
  'param.bins.label': 'ਬਿਨ',
  'param.shape.label': 'ਸ਼ੁਰੂਆਤੀ ਆਕਾਰ',
  'param.show-mean.label': 'ਔਸਤ ਦਿਖਾਓ',
  'param.show-median.label': 'ਮੱਧਕ ਦਿਖਾਓ',
  'param.x-col.label': 'X ਕਾਲਮ',
  'param.y-col.label': 'Y ਕਾਲਮ',
  'param.show-regression.label': 'ਰੀਗਰੈਸ਼ਨ ਲਾਈਨ',
  'param.show-residuals.label': 'ਅਵਸ਼ੇਸ਼',
  'param.show-confounder.label': 'ਉਲਝਾਉਣਾ ਦਿਖਾਓ',
  'param.population.label': 'ਜਨਸੰਖਿਆ',
  'param.technique.label': 'ਤਕਨੀਕ',
  'param.sample-size.label': 'ਨਮੂਨਾ ਆਕਾਰ',
  'param.stratum.label': 'ਸਤਰ',
  'param.bias.label': 'ਪੱਖਪਾਤ',
  'param.mode.label': 'ਮੋਡ',
  'param.preset.label': 'ਪ੍ਰੀਸੈੱਟ',
  'param.universe.label': 'ਬ੍ਰਹਿਮੰਡ ਆਕਾਰ',
  'param.show-prob.label': 'ਸੰਭਾਵਨਾਵਾਂ ਦਿਖਾਓ',
  'param.treat-as-numeric.label': 'ਸੰਖਿਆ ਮੰਨੋ',

  'stat.count': 'ਗਿਣਤੀ',
  'stat.mean': 'ਔਸਤ',
  'stat.median': 'ਮੱਧਕ',
  'stat.range': 'ਰੇਂਜ',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'ਵਿਚਲਿਤ',
  'stat.r': 'ਪੀਅਰਸਨ r',
  'stat.r2': 'r²',
  'stat.slope': 'ਢਾਲ',
  'stat.intercept': 'ਅੰਤਰਖੰਡ',
  'stat.n': 'n',
  'stat.population-mean': 'ਅਸਲ ਔਸਤ',
  'stat.latest-sample-mean': 'ਨਮੂਨਾ ਔਸਤ',
  'stat.sample-mean-spread': 'ਨਮੂਨਾ ਔਸਤ SD',
  'stat.sample-count': 'ਲਿਆ ਨਮੂਨਾ',
  'outlier.upper': 'ਉਪਰਲੇ ਵਿਚਲਿਤ',
  'outlier.lower': 'ਹੇਠਲੇ ਵਿਚਲਿਤ',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'ਮੁੜ-ਨਮੂਨਾ',
  'btn.run-100': '100 ਨਮੂਨੇ ਲਓ',
  'btn.stop': 'ਰੋਕੋ',
  'btn.clear-history': 'ਇਤਿਹਾਸ ਸਾਫ਼',

  'explainer.no-order': 'ਕ੍ਰਮ ਨਹੀਂ → ਸੰਚਿਤ ਨਹੀਂ, ਬਾਕਸ ਨਹੀਂ।',
  'explainer.multi-no-iqr': 'ਬਹੁ-ਮੁੱਲ → ਚੌਥਾਈ / IQR ਪਰਿਭਾਸ਼ਿਤ ਨਹੀਂ।',
  'message.no-data': 'ਡਾਟਾ ਨਹੀਂ।',
  'message.needs-quartiles': 'ਚੌਥਾਈ ਲਈ ≥4 ਬਿੰਦੂ ਚਾਹੀਦੇ।',
  'message.x-zero-variance': 'X ਦਾ ਪ੍ਰਸਰਣ ਜ਼ੀਰੋ — ਲਾਈਨ ਫਿੱਟ ਨਹੀਂ।',
  'message.n-too-small': 'n ਬਹੁਤ ਛੋਟਾ।',
  'message.stratum-clamp': 'ਸਤਰ ਵਿੱਚ ਮੰਗੀਆਂ ਨਾਲੋਂ ਘੱਟ ਪੰਕਤੀਆਂ — ਸਾਰੀਆਂ ਵਰਤੀਆਂ।',
  'message.siblings-sum-to-one': 'ਭੈਣ-ਭਰਾਵਾਂ ਦਾ ਜੋੜ 1 ਹੋਣਾ ਚਾਹੀਦਾ।',
};
